import { ORDEM_STATUS, StatusReserva, TRANSICOES } from '@/types/statusReserva'
import { DestinoPerda } from './MotivoPerdaDialog'

/**
 * Destinos que são "Perdido" (decisão 8.6): o backend exige motivo do catálogo também para
 * o back-office (400 `MOTIVO_PERDA_OBRIGATORIO`) — por isso o movimento abre o diálogo em
 * vez de mover direto. ENCERRADA por reprovação recebe o código automático no servidor.
 * Compartilhado pelo Kanban (drop) e pelo seletor de etapa da Estruturação.
 */
export const DESTINOS_PERDA: Partial<Record<StatusReserva, DestinoPerda>> = {
  CANCELADA: 'CANCELADA',
  NAO_CONVERTIDA: 'NAO_CONVERTIDA',
}

export const MSG_MOVER = 'Não foi possível mover a reserva'

/** true quando o destino exige motivo de perda (abre o `MotivoPerdaDialog`). */
export const ehDestinoPerda = (s: StatusReserva): boolean => DESTINOS_PERDA[s] != null

/**
 * Etapas para onde a reserva pode ir a partir de `status`, na ordem da jornada
 * (`ORDEM_STATUS`) — o mesmo mapa `TRANSICOES` que espelha o backend. Status
 * desconhecido/terminal = lista vazia.
 */
export const destinosPermitidos = (status: StatusReserva | null | undefined): StatusReserva[] => {
  if (!status) return []
  const permitidos = TRANSICOES[status] ?? []
  return ORDEM_STATUS.filter((s) => permitidos.includes(s))
}
